import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['card']

  static values = {
    isOpened: { type: Boolean, default: false }
  }

  connect () {
    useClickOutside(this, { element: this.cardTarget })
  }

  isOpenedValueChanged (value) {
    if (value === true) {
      this.cardTarget.classList.add('suggestion_card-opened')
      this.cardTarget.classList.remove('hidden')
    } else {
      this.cardTarget.classList.remove('suggestion_card-opened')
      this.cardTarget.classList.add('hidden')
    }
  }

  open () {
    this.isOpenedValue = true
  }

  close () {
    this.isOpenedValue = false
  }

  clickOutside (event) {
    if (this.isOpenedValue === true) {
      event.preventDefault()
      this.isOpenedValue = false
    }
  }
}
